module.exports = __webpack_public_path__ + "img/eventfy.b84d258d.png";